<template>
  <div>
    <b-card class="bg-light-secondary" v-if="ready">
      <b-card-title class="text-center mb-1 mt-1" style="font-weight: bold;">
          THI(가축 더위 지수) - 한우
      </b-card-title>
      <hr style="border: 1px dotted">
      <b>현재 온도: {{ sensors.temperature }} ℃,
          습도: {{ sensors.humidity }} ％,
          THI: {{ thi['point'] }}
          <span :style="`background-color: ${thi['color']};`">{{ thi['step'] }}</span>
        </b>
      <hr>
      <!-- <p>현재 THI 단계는 <span>{{ thi.step }}</span> 입니다.</p> -->

      <p><strong style="background-color:skyblue;">정상</strong>) 가축 사육을 위한 적정 환경</p>
      <p><strong style="background-color:greenyellow;">주의</strong>) 정상적인 활동, 온도 상승 경계</p>
      <p><strong style="background-color:yellow;">경고</strong>) 사료섭취량 14%, 증체량 ~64% 감소</p>
      <p><strong style="background-color:orange;">위험</strong>) 사료섭취량 30%, 증체량 45~75% 감소, 심박수 증가</p>
      <p><strong style="background-color:red;">심각</strong>) 폐사발생 위험, 심한 헐떡거림, 탈수, 기립불능</p>
      <b-table 
          small
          fixed
          outlined
          :items="tableData" 
          :fields="fields" 
          borderless
          class="text-center"
        >
  
          <template #cell(temp_22)="data">
            <div :style="`background-color: ${getTHIcolors(data.item, 'temp_22')}`">
              {{ data.item.temp_22 }}
            </div>
          </template>
  
          <template #cell(temp_24)="data">
            <div :style="`background-color: ${getTHIcolors(data.item, 'temp_24')}`">
              {{ data.item.temp_24 }}
            </div>
          </template>
  
          <template #cell(temp_26)="data">
            <div :style="`background-color: ${getTHIcolors(data.item, 'temp_26')}`">
              {{ data.item.temp_26 }}
            </div>
          </template>
  
          <template #cell(temp_28)="data">
            <div :style="`background-color: ${getTHIcolors(data.item, 'temp_28')}`">
              {{ data.item.temp_28 }}
            </div>
          </template>
  
          <template #cell(temp_30)="data">
            <div :style="`background-color: ${getTHIcolors(data.item, 'temp_30')}`">
              {{ data.item.temp_30 }}
            </div>
          </template>
  
          <template #cell(temp_32)="data">
            <div :style="`background-color: ${getTHIcolors(data.item, 'temp_32')}`">
              {{ data.item.temp_32 }}
            </div>
          </template>
  
          <template #cell(temp_34)="data">
            <div :style="`background-color: ${getTHIcolors(data.item, 'temp_34')}`">
              {{ data.item.temp_34 }}
            </div>
          </template>
  
          <template #cell(temp_36)="data">
            <div :style="`background-color: ${getTHIcolors(data.item, 'temp_36')}`">
              {{ data.item.temp_36 }}
            </div>
          </template>
  
          <template #cell(temp_38)="data">
            <div :style="`background-color: ${getTHIcolors(data.item, 'temp_38')}`">
              {{ data.item.temp_38 }}
            </div>
          </template>
        </b-table>
    </b-card>
  </div>
</template>

<script>
import {
  BCardBody,
  BCardTitle,
  BTable,
  BRow,
  BCard,
  BCol,
  BSpinner
} from 'bootstrap-vue'

import { getUserData } from '@/auth/utils'
import store from '@/store'
import sensor from '@/store/sensor';


export default {
  components: {
    BCardBody,
    BCardTitle,
    BTable,
    BCard,
    BSpinner,
    BRow,
    BCol,

  },
  data() {
    return {
      ready: true,
      tableData: [],
      fields: [],
      sensors: {
        temperature: 0,
        humidity: 0
      },
      thi: {
        point: 0,
        step: '',
        color: ''
      }
    }
  },
  created() {
    //this.getSensors()
    
    
  },
  mounted() {
    
  },
  methods: {
    init() {
      this.sensors.temperature = 0
      this.sensors.humidity = 0
      this.thi.point = 0
      this.thi.step = ''
      this.thi.color = ''
      this.ready = true
    },
    async getSensors (farmId) {
      this.init()
      const userId = getUserData().id
      const sensorList = await store.dispatch('sensor/getSensorList', {
        userId,
        farmId,
      });
      if(sensorList.length < 1) return this.ready = false
      for(let sensor of sensorList) {
        const Val = await store.dispatch('sensor/liveFetchSensor', { id: sensor._id });
        if (sensor.type === 'temperature') this.sensors.temperature = parseInt(Val.data / 2) * 2
        if (sensor.type === 'humidity') this.sensors.humidity = parseInt(Val.data / 5) * 5
      }
      const point = this.getTHIndexPoint(this.sensors.temperature, this.sensors.humidity)
      this.thi['point'] = point
      this.thi['step'] = this.getTHIndexStepsByPoint(point)['text']
      this.thi['color'] = this.getTHIndexStepsByPoint(point)['color']
      this.sensorList = sensorList
      this.makeTHIndexTable()
      this.getFields()
      return {sensors: this.sensors, thi: this.thi}
    },
    makeTHIndexTable() {
      this.tableData = []
        for (let humidity = 5; humidity <= 100; humidity += 5) {
          const row = { humidity: `${humidity}` } 
          for (let temp = 22; temp <= 38; temp += 2) {
            const value = this.getTHIndexPoint(temp, humidity)
            row[`temp_${temp}`] = value
          }
          this.tableData.push(row)
        }
      return 
    },
    getFields () {
      this.fields = [{ key: "humidity", label: "℃%" }]
        for (let temp = 22; temp <= 38; temp += 2) {
          this.fields.push({ 
            key: `temp_${temp}`, 
            label: `${temp}`,
          })
        }
      return 
    },
    getTHIndexPoint (temperature, humidity) {
      return parseInt((1.8 * temperature + 32) - ((0.55 - 0.0055 * humidity) * (1.8 * temperature - 26.8)))
    },
    getTHIndexStepsByPoint (point) {
      if(point < 72) return {text: '정상', color: 'rgba(135, 206, 235, 0.7)'}
        else if(point < 78) return {text: '주의', color: 'rgba(173, 255, 47, 0.7)'}
        else if(point < 89) return {text: '경고', color: 'rgba(255, 255, 0, 0.7)'}
        else if(point < 98) return {text: '위험', color: 'rgba(255, 165, 0, 0.7)'}
        else return {text: '심각', color: 'rgba(255, 0, 0, 0.7)'}
    },
    getTHIcolors(items, target) {
        const temp = target.split('_')[1];
        const isCurrentSensor =
          (items.humidity == this.sensors.humidity) && (temp == this.sensors.temperature)
  
        if (isCurrentSensor) {
          const point = this.getTHIndexPoint(this.sensors.temperature, this.sensors.humidity);
          this.thindex = {
            point,
            step: this.getTHIndexStepsByPoint(point)['text'],
          };
          return 'rgba(255, 0, 255, 0.7)';
        }
        const { color } = this.getTHIndexStepsByPoint(items[target]);
        return color;
      }
  },
}
</script>

<style>


</style>
